<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 19 20">
    <path
      d="M14.0896 1.02016V1.76652L17.4845 1.75064L12.7095 6.45509L12.603 6.36378C11.3058 5.23233 9.64574 4.60507 7.92263 4.60507C3.98353 4.60904 0.777832 7.83666 0.777832 11.8027C0.777832 15.7687 3.98353 18.9963 7.92263 18.9963C11.8617 18.9963 15.0714 15.7687 15.0714 11.8027C15.0714 10.0718 14.4523 8.39643 13.3246 7.09029L13.23 6.9831L17.9971 2.28262L17.9104 5.69682L18.6517 5.71667L18.7699 1.04001V0.996338L14.0856 1.01619L14.0896 1.02016ZM12.465 7.22924C13.0565 7.82078 13.5178 8.51156 13.8411 9.28571C14.1763 10.0837 14.3458 10.9293 14.3458 11.8027C14.3458 12.6761 14.1763 13.5217 13.8411 14.3197C13.5178 15.0899 13.0525 15.7846 12.465 16.3761C11.8775 16.9716 11.1875 17.4361 10.4225 17.7617C9.62997 18.0991 8.78616 18.2698 7.92263 18.2698C7.0591 18.2698 6.21529 18.0991 5.42274 17.7617C4.65779 17.4361 3.9717 16.9677 3.38024 16.3761C2.79273 15.7846 2.32745 15.0938 2.00412 14.3197C1.66896 13.5217 1.49941 12.6761 1.49941 11.8027C1.49941 10.9293 1.66896 10.0797 2.00412 9.28571C2.32745 8.51553 2.79273 7.82078 3.38024 7.22924C3.9717 6.63374 4.65779 6.16528 5.42274 5.84371C6.21529 5.50626 7.07093 5.33555 7.92263 5.33555C8.77433 5.33555 9.62997 5.50626 10.4225 5.84371C11.1875 6.16925 11.8736 6.63771 12.465 7.22924Z"
      :class="colorClass"
      stroke-width="0.3"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
